module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_library.js
// module id = 37
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/_library.js